import { FontConfig } from "../types"

export const HEADING_1_CONFIG: FontConfig = {
  title: "Headings/h1",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 28, tw: "text-[28px]" },
    lineHeight: { px: 102, tw: "leading-[62px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 48, tw: "text-[48px]" },
    lineHeight: { px: 102, tw: "leading-[82px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 68, tw: "text-[68px]" },
    lineHeight: { px: 102, tw: "leading-[102px]" },
  },
}
